// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArticlePage_articlePage__9Jquo {
  color: var(--color-text);
  margin-top: calc(var(--space-lg) + 100px);
  text-align: center;
}

.ArticlePage_header__xMW70 {
  margin-bottom: var(--space-lg);
}

.ArticlePage_title__jPmrg {
  font-size: 3.2rem;
  font-weight: 400;
  margin-bottom: var(--space-xs);
  text-wrap: balance;
}

.ArticlePage_subtitle__-85By {
  font-size: 1.4rem;
  font-weight: 400;
  margin-bottom: var(--space-xs);
  text-wrap: balance;
}

.ArticlePage_date__VxDQ6 {
  font-size: var(--font-size-small);
  margin-bottom: var(--space-xs);
  font-weight: 400;
}

.ArticlePage_image__155Cx {
  width: 100%;
  max-width: 90%;
  max-height: 40%;
  margin-top: 4rem;
  margin-bottom: var(--space-md);
  border-radius: 10px;
  transition: transform 0.4s ease; /* Smooth transition for transform */
}

.ArticlePage_image__155Cx:hover {
  transform: scale(1.005); /* Slightly expand the image on hover */
}

.ArticlePage_content__yMfja {
  text-align: left;
  padding-left: 8rem;
  padding-right: 8rem;
}

.ArticlePage_heading__HDtgC {
  font-size: 1.4rem;
  font-weight: 400;
  margin-bottom: var(--space-sm);
  margin-top: 3rem;
}

.ArticlePage_sectionContent__pE\\+c7 {
  font-size: var(--font-size-base);
  margin-bottom: var(--space-lg);
  line-height: var(--line-height-base);
}

/* Add styles for unordered lists and list items */
.ArticlePage_sectionContent__pE\\+c7 ul {
  padding-left: 1.5em;
  margin-bottom: var(--space-lg);
  margin-top: 0.8rem;
}

.ArticlePage_sectionContent__pE\\+c7 li {
  margin-bottom: 0.5em;
}

/* mobile styles */
@media (max-width: 768px) {
  .ArticlePage_content__yMfja {
    padding-left: 14px;
    padding-right: 14px;
  }

  .ArticlePage_image__155Cx {
    max-width: 95%;
  }
}

/* on larger screens cap image width */
@media (min-width: 1200px) {
  .ArticlePage_image__155Cx {
    max-width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ArticlePage.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B,EAAE,oCAAoC;AACvE;;AAEA;EACE,uBAAuB,EAAE,uCAAuC;AAClE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".articlePage {\n  color: var(--color-text);\n  margin-top: calc(var(--space-lg) + 100px);\n  text-align: center;\n}\n\n.header {\n  margin-bottom: var(--space-lg);\n}\n\n.title {\n  font-size: 3.2rem;\n  font-weight: 400;\n  margin-bottom: var(--space-xs);\n  text-wrap: balance;\n}\n\n.subtitle {\n  font-size: 1.4rem;\n  font-weight: 400;\n  margin-bottom: var(--space-xs);\n  text-wrap: balance;\n}\n\n.date {\n  font-size: var(--font-size-small);\n  margin-bottom: var(--space-xs);\n  font-weight: 400;\n}\n\n.image {\n  width: 100%;\n  max-width: 90%;\n  max-height: 40%;\n  margin-top: 4rem;\n  margin-bottom: var(--space-md);\n  border-radius: 10px;\n  transition: transform 0.4s ease; /* Smooth transition for transform */\n}\n\n.image:hover {\n  transform: scale(1.005); /* Slightly expand the image on hover */\n}\n\n.content {\n  text-align: left;\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n\n.heading {\n  font-size: 1.4rem;\n  font-weight: 400;\n  margin-bottom: var(--space-sm);\n  margin-top: 3rem;\n}\n\n.sectionContent {\n  font-size: var(--font-size-base);\n  margin-bottom: var(--space-lg);\n  line-height: var(--line-height-base);\n}\n\n/* Add styles for unordered lists and list items */\n.sectionContent ul {\n  padding-left: 1.5em;\n  margin-bottom: var(--space-lg);\n  margin-top: 0.8rem;\n}\n\n.sectionContent li {\n  margin-bottom: 0.5em;\n}\n\n/* mobile styles */\n@media (max-width: 768px) {\n  .content {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .image {\n    max-width: 95%;\n  }\n}\n\n/* on larger screens cap image width */\n@media (min-width: 1200px) {\n  .image {\n    max-width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articlePage": `ArticlePage_articlePage__9Jquo`,
	"header": `ArticlePage_header__xMW70`,
	"title": `ArticlePage_title__jPmrg`,
	"subtitle": `ArticlePage_subtitle__-85By`,
	"date": `ArticlePage_date__VxDQ6`,
	"image": `ArticlePage_image__155Cx`,
	"content": `ArticlePage_content__yMfja`,
	"heading": `ArticlePage_heading__HDtgC`,
	"sectionContent": `ArticlePage_sectionContent__pE+c7`
};
export default ___CSS_LOADER_EXPORT___;
